export default __webpack_public_path__ + "static/media/ARK_wide.fb8fdea4.png";